module.exports = require("@material-ui/core/ListItemText");